import React from 'react';

export const name = 'search';

export const Search = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#6C717C"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1824 17.7076C15.1589 17.7076 18.3824 14.4841 18.3824 10.5076C18.3824 6.53117 15.1589 3.30762 11.1824 3.30762C7.20597 3.30762 3.98242 6.53117 3.98242 10.5076C3.98242 14.4841 7.20597 17.7076 11.1824 17.7076Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M15.6748 16.3501L20.0173 20.6926"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
  </svg>
);
